import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

import { userState } from "../../store/user";

import classes from "./NotificationsIcon.module.css";

interface Props {
  notificationsCount: number;
  setNotificationsCount: React.Dispatch<React.SetStateAction<number>>;
}

const NotificationsIcon: FC<Props> = ({
  notificationsCount,
  setNotificationsCount,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const location = useLocation();
  useEffect(() => {
    console.log("notifications icon use effect");
    const getNotificationsCount = async () => {
      await axios
        .get(`${API_URL}/notifications/count`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setNotificationsCount(response.data.count);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const interval = setInterval(() => {
      getNotificationsCount();
    }, 60000);

    getNotificationsCount();

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <Link
      to="/notifications"
      className={`${classes.notificationsIcon} ${
        notificationsCount === 0 ||
        location.pathname === "/vote" ||
        location.pathname === "/notifications"
          ? classes.hidden
          : ""
      }`}
    >
      <svg viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.9455 23.0293C11.9455 23.5028 12.8338 24 13.3273 24C13.8208 24 14.7091 23.5028 14.7091 23.0293H11.9455Z"
          fill="#868686"
        />
        <path
          d="M12.3403 4.93159C12.653 4.90692 12.9817 4.89402 13.3273 4.89402C13.6728 4.89402 14.0016 4.90692 14.3143 4.93159V3.94701C14.3143 3.63134 14.1169 3 13.3273 3C12.5377 3 12.3403 3.63134 12.3403 3.94701V4.93159Z"
          fill="#868686"
        />
        <path
          d="M12.3403 4.93159C12.653 4.90692 12.9817 4.89402 13.3273 4.89402C13.6728 4.89402 14.0016 4.90692 14.3143 4.93159M12.3403 4.93159C7.29338 5.32963 6.41819 8.79259 6.41819 10.5761C6.41819 12.4701 6.41819 16.5423 6.41819 17.6787C6.41819 18.8151 4.49351 19.9041 4 20.3776H23C22.5065 19.9041 20.2364 18.8151 20.2364 17.6787C20.2364 16.5423 20.2364 12.4701 20.2364 10.5761C20.2364 8.79259 19.3612 5.32963 14.3143 4.93159M12.3403 4.93159V3.94701C12.3403 3.63134 12.5377 3 13.3273 3C14.1169 3 14.3143 3.63134 14.3143 3.94701V4.93159M11.9455 23.0293C11.9455 23.5028 12.8338 24 13.3273 24C13.8208 24 14.7091 23.5028 14.7091 23.0293H11.9455Z"
          stroke="#868686"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{notificationsCount}</span>
    </Link>
  );
};

export default NotificationsIcon;
